import { fetch } from '../utils/request';

import { MONO_BASE } from './services';

const getUrl = (path) => `${MONO_BASE}${path}`;

export default {
  getPoll(id) {
    return fetch(getUrl(`/public/polls/${id}`), {
      headers: {},
    });
  },
};
